import React from 'react'

/**
 * Deprecated, since it doesn't work properly if it's not full screen. Didn't want to change this component since it may break
 * things. Going forward, please use ProcessingOverlayComponent instead.
 */
class ProcessingComponent extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        const {show=false, fullscreen=true, message="Processing"} = this.props;
        if (show){
            const loaderOverlayStyling = fullscreen ? "loader-overlay loader-fullscreen" : "loader-overlay";
            return (
                <div style={{position: "relative"}}>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <div className={loaderOverlayStyling}>
                        <div className="loader-wrapper">
                            <div className="loader"></div>
                            <p>{message}...</p>
                        </div>
                    </div>
                </div>
            );
        } else {
            return <div></div>;
        }
    }
}

export default ProcessingComponent;